var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center py-4 pb-6"},[_vm._t("navigation"),_c('span',{staticClass:"text-h2 font-weight-bold"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }